// extracted by mini-css-extract-plugin
export default {"link":"link___MNNuV","wrapper":"wrapper___K4D59","content":"content___RBVO4"};